<template>
  <div id="Lgx02887700413887576801683" class="al">
    <vx-card>
      <div class="al-header">
        <svg class="al-logo" viewBox="0 0 2400 2800" role="img" aria-label="Twitch">
          <polygon fill="#ffffff" points="2200,1300 1800,1700 1400,1700 1050,2050 1050,1700 600,1700 600,200 2200,200" />
          <path
            fill="#9146ff"
            d="M500,0L0,500v1800h600v500l500-500h400l900-900V0H500z M2200,1300l-400,400h-400l-350,350v-350H600V200h1600V1300z"
          />
          <rect x="1700" y="550" width="200" height="600" fill="#9146ff" />
          <rect x="1150" y="550" width="200" height="600" fill="#9146ff" />
        </svg>
        <div class="al-header-text">
          <h3 class="al-title">Partner payouts handover</h3>
          <p class="al-subtitle">Twitch Partner Operations · HR-2291 · partner-ops01</p>
        </div>
      </div>

      <div class="al-handover">
        <div v-for="person in people" :key="person.user" class="al-person">
          <img :src="person.photo" :alt="person.name" class="al-avatar" :class="{ 'is-new': person.isNew }" />

          <div class="al-person-text">
            <span class="al-person-name">{{ person.name }}</span>
            <span class="al-person-role">{{ person.role }}</span>
            <span class="al-person-meta">
              <span class="al-mono">{{ person.home }}</span>
              · {{ person.status }}
            </span>
          </div>
        </div>
        <font-awesome-icon :icon="['far', 'arrow-right']" class="al-handover-arrow" />
      </div>
    </vx-card>

    <div class="al-grid">
      <vx-card class="al-tree-card">
        <h4 class="al-card-title">partner-ops01 filesystem</h4>
        <pre class="al-tree"><span v-for="(line, index) in treeLines" :key="index" :class="line.cls">{{ line.text }}
</span></pre>
      </vx-card>

      <vx-card>
        <div class="al-builder-head">
          <div class="al-switch" role="tablist">
            <button
              v-for="tab in tabs"
              :key="tab.id"
              type="button"
              role="tab"
              class="al-switch-option"
              :class="{ 'is-active': activeTab === tab.id }"
              :aria-selected="activeTab === tab.id"
              @click="activeTab = tab.id"
            >
              {{ tab.label }}
              <font-awesome-icon v-if="results[tab.id] === true" :icon="['far', 'check']" class="al-switch-state is-correct" />
              <font-awesome-icon v-if="results[tab.id] === false" :icon="['far', 'xmark']" class="al-switch-state is-wrong" />
            </button>
          </div>
          <p class="al-builder-hint">{{ hints[activeTab] }}</p>
        </div>

        <div class="al-bank">
          <button
            v-for="token in tokens"
            :key="token.id"
            type="button"
            class="al-token"
            :class="{ 'is-space': token.id === 'space', 'is-used': isUsed(token.id) }"
            :disabled="isUsed(token.id)"
            @click="addToken(token.id)"
          >
            {{ token.label }}
          </button>
        </div>

        <div class="al-command-line" :class="resultClass(activeTab)">
          <div class="al-command">
            <span class="al-prompt">[root@partner-ops01 ~]#</span>
            <span class="al-fixed">tar</span>
            <template v-for="(tokenId, index) in commands[activeTab]">
              <span
                v-if="tokenId === 'space'"
                :key="`${activeTab}-${index}`"
                class="al-part al-part-space"
                title="Remove space"
                @click="removeAt(index)"
              ></span>
              <span v-else :key="`${activeTab}-${index}`" class="al-part" title="Remove" @click="removeAt(index)">{{ tokenValue(tokenId) }}</span>
            </template>
            <span class="al-cursor" aria-hidden="true"></span>
          </div>
          <div class="al-actions">
            <button type="button" class="al-icon-button" :disabled="!commands[activeTab].length" title="Remove last object" @click="backspace">
              <font-awesome-icon :icon="['far', 'delete-left']" />
            </button>
            <button type="button" class="al-icon-button" :disabled="!commands[activeTab].length" title="Clear command" @click="clearLine">
              <font-awesome-icon :icon="['far', 'rotate-left']" />
            </button>
          </div>
        </div>
        <div v-if="results[activeTab] === true" class="al-output">
          <p v-for="line in outputLines" :key="line">{{ line }}</p>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import alicePhoto from '@/assets/images/simulations/archive-lifecycle/alice-patel.jpg';
import bobPhoto from '@/assets/images/simulations/archive-lifecycle/bob-kim.jpg';

const SPACE = 'space';

const ARCHIVE_MEMBERS = [
  'alice/',
  'alice/.bashrc',
  'alice/notes.md',
  'alice/contracts/',
  'alice/contracts/streamer-agreements.pdf',
  'alice/payouts/',
  'alice/payouts/q3-payouts.csv',
  'alice/payouts/q4-forecast.xlsx',
];

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      activeTab: 'archive',
      tabs: [
        { id: 'archive', label: 'Archive' },
        { id: 'extract', label: 'Extract' },
      ],
      hints: {
        archive: 'Archive all the files from Alice’s home directory.',
        extract: 'Extract the archive into Bob’s home directory.',
      },
      people: [
        {
          user: 'alice',
          photo: alicePhoto,
          name: 'Alice Patel',
          role: 'Former partner payouts lead',
          home: '/home/alice',
          status: 'account disabled',
          isNew: false,
        },
        {
          user: 'bob',
          photo: bobPhoto,
          name: 'Bob Kim',
          role: 'New partner payouts lead',
          home: '/home/bob',
          status: 'active',
          isNew: true,
        },
      ],
      tokens: [
        '/home/',
        '-cJvf',
        '-d',
        '-xvf',
        '/tmp/alice.tar',
        '/tmp/alice.tgz',
        'alice',
        '-xzvf',
        '-C',
        '-xjvf',
        '-c',
        '/tmp/alice.tar.bz2',
        '-cvf',
        'bob',
        '/tmp/alice.tar.gz',
        SPACE,
        '-czvf',
        '-tvf',
        '/root/',
        '/tmp/alice.tar.xz',
      ].map((value) => {
        if (value === SPACE) return { id: SPACE, label: '␣ space', value: ' ' };
        return { id: value, label: value, value };
      }),
      commands: {
        archive: [],
        extract: [],
      },
      results: {
        archive: null,
        extract: null,
      },
      accepted: {
        archive: ['tar -cvf /tmp/alice.tar -C /home/ alice', 'tar -C /home/ -cvf /tmp/alice.tar alice'],
        extract: [
          'tar -xvf /tmp/alice.tar -C /home/bob',
          'tar -C /home/bob -xvf /tmp/alice.tar',
          'tar -xvf /tmp/alice.tar -C /home/bob alice',
          'tar -C /home/bob -xvf /tmp/alice.tar alice',
        ],
      },
      outputLines: ARCHIVE_MEMBERS,
    };
  },
  computed: {
    treeLines() {
      const lines = [
        { text: '/', cls: '' },
        { text: '├── home/', cls: '' },
        { text: '│   ├── alice/', cls: 'is-source' },
        { text: '│   │   ├── .bashrc', cls: 'is-dim' },
        { text: '│   │   ├── notes.md', cls: 'is-dim' },
        { text: '│   │   ├── contracts/', cls: 'is-dim' },
        { text: '│   │   │   └── streamer-agreements.pdf', cls: 'is-dim' },
        { text: '│   │   └── payouts/', cls: 'is-dim' },
        { text: '│   │       ├── q3-payouts.csv', cls: 'is-dim' },
        { text: '│   │       └── q4-forecast.xlsx', cls: 'is-dim' },
        { text: '│   └── bob/', cls: 'is-target' },
      ];
      if (this.results.extract === true) {
        lines.push({ text: '│       └── alice/', cls: 'is-new' });
      }
      lines.push({ text: '├── root/          ← you are here', cls: 'is-here' });
      lines.push({ text: '└── tmp/', cls: '' });
      if (this.results.archive === true) {
        lines.push({ text: '    └── alice.tar', cls: 'is-new' });
      }
      return lines;
    },
  },
  methods: {
    tokenValue(tokenId) {
      return this.tokens.find((token) => token.id === tokenId).value;
    },
    isUsed(tokenId) {
      return tokenId !== SPACE && this.commands[this.activeTab].includes(tokenId);
    },
    touch() {
      this.results[this.activeTab] = null;
    },
    addToken(tokenId) {
      if (this.isUsed(tokenId)) return;
      this.commands[this.activeTab].push(tokenId);
      this.touch();
    },
    removeAt(index) {
      this.commands[this.activeTab].splice(index, 1);
      this.touch();
    },
    backspace() {
      this.commands[this.activeTab].pop();
      this.touch();
    },
    clearLine() {
      this.commands[this.activeTab] = [];
      this.touch();
    },
    commandText(tab) {
      const parts = this.commands[tab].map((tokenId) => this.tokenValue(tokenId)).join('');
      return `tar ${parts}`.replace(/\s+/g, ' ').trim();
    },
    resultClass(tab) {
      return { 'is-correct': this.results[tab] === true, 'is-wrong': this.results[tab] === false };
    },
    markSimulation() {
      let totalScore = 0;

      this.tabs.forEach(({ id }) => {
        const correct = this.accepted[id].includes(this.commandText(id));
        this.results[id] = correct;
        if (correct) totalScore++;
      });

      if (totalScore === this.tabs.length) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
#Lgx02887700413887576801683 {
  --al-mono: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  --al-purple: #9146ff;
  --al-purple-light: #bf94ff;
  --al-black: #06070d;
  --al-raised: #0c0e1a;
  --al-line: #1d2133;
  --al-line-strong: #2d3249;
  --al-text: #e4e6ef;
  --al-muted: #a3a8bd;
  --al-green: #31b952;
  --al-red: #e5484d;

  width: 100%;
  min-width: 0;
  font-size: 1.02rem;

  > * + * {
    margin-top: 1.5rem;
  }
}

.al-mono {
  font-family: var(--al-mono);
}

.al-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.al-logo {
  flex-shrink: 0;
  width: auto;
  height: 2.6rem;
}

.al-title {
  margin: 0;
  color: #ffffff;
  font-size: 1.25rem;
  font-weight: 600;
}

.al-subtitle {
  margin: 0.2rem 0 0;
  color: var(--al-muted);
}

.al-handover {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 3rem;
  margin-top: 1.5rem;
}

.al-handover-arrow {
  position: absolute;
  top: 50%;
  left: 50%;
  color: var(--al-purple-light);
  font-size: 1.25rem;
  transform: translate(-50%, -50%);
}

.al-person {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  padding: 0.9rem 1rem;
  border: 1px solid var(--al-line);
  border-radius: 0.5rem;
  background: var(--al-raised);
}

.al-avatar {
  flex-shrink: 0;
  width: 3.5rem;
  height: 3.5rem;
  border: 2px solid var(--al-line-strong);
  border-radius: 999px;
  object-fit: cover;
  filter: grayscale(0.7);

  &.is-new {
    border-color: var(--al-purple);
    filter: none;
  }
}

.al-person-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.al-person-name {
  color: #ffffff;
  font-weight: 600;
}

.al-person-role,
.al-person-meta {
  color: var(--al-muted);
  font-size: 0.95rem;
}

.al-person-meta .al-mono {
  color: var(--al-text);
}

.al-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.9fr);
  gap: 1.5rem;
  align-items: start;
}

.al-card-title {
  margin: 0 0 1rem;
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 600;
}

.al-tree {
  margin: 0;
  padding: 1rem;
  overflow-x: auto;
  border: 1px solid var(--al-line);
  border-radius: 0.5rem;
  background: var(--al-black);
  color: var(--al-text);
  font-family: var(--al-mono);
  font-size: 0.95rem;
  line-height: 1.6;

  .is-dim {
    color: var(--al-muted);
  }

  .is-source,
  .is-target {
    color: #ffffff;
    font-weight: 600;
  }

  .is-here {
    color: var(--al-purple-light);
  }

  .is-new {
    color: var(--al-green);
  }
}

.al-builder-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
}

.al-switch {
  display: inline-flex;
  padding: 0.25rem;
  border: 1px solid var(--al-line-strong);
  border-radius: 0.5rem;
  background: var(--al-black);
}

.al-switch-option {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 1.1rem;
  border: 0;
  border-radius: 0.35rem;
  background: transparent;
  color: var(--al-muted);
  font: inherit;
  font-weight: 600;
  cursor: pointer;

  &.is-active {
    background: var(--al-purple);
    color: #ffffff;
  }
}

.al-switch-state {
  &.is-correct {
    color: var(--al-green);
  }

  &.is-wrong {
    color: var(--al-red);
  }
}

.al-switch-option.is-active .al-switch-state {
  color: #ffffff;
}

.al-builder-hint {
  margin: 0;
  color: var(--al-muted);
}

.al-bank {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(13.5rem, 100%), 1fr));
  gap: 0.55rem;
  margin-top: 1.5rem;
}

.al-token {
  min-width: 0;
  padding: 0.6rem 0.75rem;
  border: 1px solid var(--al-line);
  border-radius: 0.4rem;
  background: var(--al-raised);
  color: var(--al-text);
  font-family: var(--al-mono);
  font-size: 1rem;
  line-height: 1.3;
  white-space: nowrap;
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: var(--al-purple);
  }

  &.is-space {
    border-style: dashed;
    border-color: var(--al-line-strong);
    color: var(--al-muted);
  }

  &.is-used {
    border-color: var(--al-line);
    border-style: solid;
    background: transparent;
    color: #4a4f66;
    cursor: not-allowed;
  }
}

.al-command-line {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-top: 1.5rem;
  padding: 1rem;
  border: 1px solid var(--al-line);
  border-radius: 0.5rem;
  background: var(--al-black);

  &.is-correct {
    border-color: var(--al-green);
  }

  &.is-wrong {
    border-color: var(--al-red);
  }
}

.al-command {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  align-items: center;
  min-width: 0;
  min-height: 2rem;
  color: var(--al-text);
  font-family: var(--al-mono);
  font-size: 1.2rem;
  line-height: 1.6;
}

.al-prompt {
  margin-right: 0.6rem;
  color: var(--al-purple-light);
}

.al-fixed {
  margin-right: 0.6ch;
}

.al-part {
  border-radius: 0.2rem;
  cursor: pointer;

  &:hover {
    color: var(--al-red);
    text-decoration: line-through;
  }
}

.al-part-space {
  display: inline-block;
  width: 0.75ch;
  height: 1.2em;
  border-bottom: 1px dashed var(--al-line-strong);

  &:hover {
    border-bottom-color: var(--al-red);
  }
}

.al-cursor {
  display: inline-block;
  width: 0.6ch;
  height: 1.15em;
  margin-left: 1px;
  background: var(--al-text);
  animation: al-blink 1.1s steps(1) infinite;
}

@keyframes al-blink {
  50% {
    opacity: 0;
  }
}

.al-actions {
  display: flex;
  flex-shrink: 0;
  gap: 0.4rem;
}

.al-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.1rem;
  height: 2.1rem;
  border: 1px solid var(--al-line);
  border-radius: 0.35rem;
  background: var(--al-raised);
  color: var(--al-text);
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: var(--al-purple);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}

.al-output {
  margin-top: 0.75rem;
  color: var(--al-muted);
  font-family: var(--al-mono);
  font-size: 0.95rem;
  line-height: 1.45;

  p {
    margin: 0;
  }
}

@media (max-width: 1100px) {
  .al-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 720px) {
  .al-handover {
    grid-template-columns: minmax(0, 1fr);
    gap: 1rem;
  }

  .al-handover-arrow {
    display: none;
  }

  .al-command {
    font-size: 1.05rem;
  }
}
</style>
